import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/Home.vue'
import JumpPage from '@/views/JumpPage.vue'
import NewHome from '@/views/NewHome.vue'
import HotelService from '@/views/HotelService.vue'
import ButlerQrcode from '@/views/ButlerQrcode.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'HomePage',
    component: HotelService,
    meta: { title: 'Hotel' }
  },
  // 根路径重定向到 /home
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/jump',
    name: 'jumpPage',
    component: JumpPage
  },
  {
    path: '/newHome',
    name: 'NewHomePage',
    component: NewHome
  },
  {
    // 兼容旧链接
    path: '/hotel',
    redirect: '/home'
  },
  {
    path: '/butler-qrcode',
    name: 'ButlerQrcode',
    component: ButlerQrcode,
    meta: { title: '联系酒店服务管家' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
